import { Styles, generateClasses } from 'netline-ui';

export const loadingProgressClasses = generateClasses('LoadingProgress', ['root', 'progress', 'text'] as const);

const styles: Styles = ({ theme: { spacing } }) => ({
  [`&.${loadingProgressClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexGrow: 1,
    height: '100%',
  },

  [`.${loadingProgressClasses.text}`]: {
    width: '100%',
    wordWrap: 'break-word',
    marginTop: spacing(2),
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
});

export default styles;
